import { CHANGE_LANGUAGE } from "./languageState"

interface langState {
  language: Record<string, any>;
  code:string
}
export default (state: langState, action: any) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};
